export default __webpack_public_path__ + "static/girl-man-e423fd9523429a43a54264c515596627.png";